import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import HRCampusSelector from "../../components/HRCampusSelector";

export default function UniformsLayout() {
  const [campus, setCampus] = React.useState(() => {
    try { return localStorage.getItem("uniforms_last_campus") || "bulacan"; } catch { return "bulacan"; }
  });
  React.useEffect(() => {
    try { localStorage.setItem("uniforms_last_campus", campus); } catch (e) { void 0; }
  }, [campus]);
  return (
    <div className="container-fluid px-0">
      <div className="px-4 py-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Uniforms Inventory & Sales</h2>
        <HRCampusSelector selectedCampus={campus} onChange={setCampus} />
      </div>
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <NavLink className="nav-link" to="inventory">Inventory</NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link" to="sales">Sales</NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link" to="deliveries">Deliveries</NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link" to="orders">Orders</NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link" to="products">Products</NavLink>
        </li>
        <li className="nav-item">
          <NavLink className="nav-link" to="reports">Sales Report</NavLink>
        </li>
      </ul>
      <Outlet context={{ campus }} />
      </div>
    </div>
  );
}
